import { render, staticRenderFns } from "./SchedaMorteDatiInizialiComponent.vue?vue&type=template&id=0da807c6"
import script from "./SchedaMorteDatiInizialiComponent.vue?vue&type=script&lang=js"
export * from "./SchedaMorteDatiInizialiComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports